angular.module('callX').controller('ContactDetailsCtrl', ['$scope','$stateParams','$modal','UserService','$rootScope', '$state', 'toaster', function($scope,$stateParams,$modal,UserService, $rootScope,$state, toaster) {
    
    var username_agent = $stateParams.username;
    // console.log($stateParams,"get data")
    $scope.contactName = $stateParams.contactName;
    $scope.contactphoneNumber = $stateParams.phoneNumber;

    $scope.processContactName = function(contact_Name) {
        $scope.contactName = contact_Name;
            if ($scope.contactName && $scope.contactName.includes("null")){
                $scope.contactName = 'Unknown Contact';
                $scope.firstNameFirstLetter =  null;
            }else {
                var names = $scope.contactName.split(' ');
                $scope.firstName = names[0]; 
                $scope.lastName = names.slice(1).join(' '); 
            
                var firstLetter = $scope.firstName.charAt(0).toUpperCase();
                var lastLetter = $scope.lastName.charAt(0).toUpperCase();
                $scope.firstNameFirstLetter = firstLetter;
                $scope.lastNameFirstLetter = lastLetter ;
            }
    }

    $scope.contactFUllName = $stateParams.contactName;
    $scope.phoneNumber = $stateParams.phoneNumber;
    $scope.processContactName($scope.contactFUllName)
  

    var userId = $stateParams.userId;
    $scope.role ;
    $scope.getuserRole ;
    $scope.getsalesRole ;
    $scope.contactDetailsData;
    $scope.editCustomerInfo = false;
    $scope.notes = ''; 
    $scope.editData = {};
    // $scope.contactDetailsData;
    $rootScope.oldStageValue;
    $scope.loading = false;
    $scope.showNoOffersMessage = false;
    $scope.companies;
    $rootScope.agentNames;

    $scope.tableContentLoading=false; 

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_name = window.localStorage.getItem("user_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role")

        if ($scope.role === 'AGENT') {
            $scope.role = 'salesagent';
        }
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }
    $scope.setAgentFirsAandLastName();

    $scope.limitTextLength = function(text) {
        return text.slice(0,4) + '..'
    } 

    $scope.navigateToCustomers = function(){ 
        if($rootScope.currentPage === 'callhistory'){
            $rootScope.currentPage = 'contactpage' 
        }
        $state.go('app.sales-agent.contacts');
    }  

    $scope.stages = ["Application Submitted", "Pending", "No Sale", "Refund"];

    // multi selection code 
    // $scope.checkedStages = {};
    // $scope.selectedStages = [];
    //     $scope.updateSelectedStages = function() {
    //         $scope.selectedStages = [];
    //         console.log($scope.checkedStages , "checked stage values")
    //         for (var stage in $scope.checkedStages) {
    //             if ($scope.checkedStages[stage]) {
    //                 $scope.selectedStages.push(stage);
    //             }
    //         }
    //         console.log($scope.selectedStages, "selected stages")
    //     };

        // single selection code 
        $scope.selectStage = function(stage) {
            $scope.selectedStage = stage;
        };

    //stage functions ends

    $scope.formatDateTime = function(inputDate) {
        var dateObject = new Date(inputDate); 
        var formattedDate = (dateObject.getMonth() + 1).toString().padStart(2, '0') + '/' + (dateObject.getDate()).toString().padStart(2, '0') + '/' + dateObject.getFullYear();
        var formattedTime = inputDate.split('T')[1].substring(0, 5);
        var formattedDateTime = formattedDate + ' | ' + formattedTime + ' ' + 'PST';
        return formattedDateTime;
      }

    $scope.formatDuration = function(timeString) {
        var formattedTime;
        if (timeString.toString()) {
            var hours = Math.floor(timeString / 60);
            var minutes = timeString % 60;
            return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
        } else {
            formattedTime = ''
        }
        return formattedTime;
    };

    $scope.getsalesCallerDetails = function(id){
        var callbacks = {
            success: function(data) {
                $scope.salesuserDetails = data.data;
                $scope.salesuserCallId = data.data.id;
                $scope.salesuserEmail = data.data.email;  
                data.data.email = $scope.staticCustomerDetails.email;       
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getSalesUserDetails(id,userId,callbacks);
    };

    $scope.agentContactDetails = function(){
        $scope.tableContentLoading = true;
        $scope.callsblock = true;
        $scope.notesblock= false;
        $scope.application = false;

        var callbacks = {
        success: function(data) {
            console.log(data, "get contact details data ----------->")
           $scope.contactDetailsData = data.data.sales_agent_contact;
           $rootScope.contactId = $scope.contactDetailsData.id;
           $scope.selectedStage = data.data.sales_agent_contact.root_disposition;
           $rootScope.oldStageValue = data.data.sales_agent_contact.root_disposition;
           if(data.data.sales_agent_contact.notes != null){
               $scope.notes = data.data.sales_agent_contact.notes;
           }
           // console.log($scope.notes)
           $scope.contactCallData = data.data.conctact_calls_list;
           $scope.contactDay = data.data.dob_day;
           $scope.contactMonth = data.data.dob_month;
           $scope.contactYear = data.data.dob_year;
           $scope.tableContentLoading = false;
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        };
        UserService.getContactsDetailsView($scope.phoneNumber,$scope.user_id,callbacks); 
    }
    $scope.agentContactDetails();  
    
    $scope.checkZipcode = function() {
         var edit_zipcode = $scope.editData && $scope.editData.zip_code;
         var static_zipcode = $scope.contactDetailsData && $scope.contactDetailsData.zip_code;
         
        var check_zipcode = edit_zipcode !== undefined && edit_zipcode !== null ? edit_zipcode : $scope.contactDetailsData.zip_code;
        if (check_zipcode && check_zipcode.length === 5 ) { 
            var callbacks = {
                success: function(data) {
                    if (data.data) {
                        $scope.location = data.data;
                        if (edit_zipcode !== undefined && edit_zipcode !== null) {
                            $scope.editData.city = $scope.location.city;
                            $scope.editData.state = $scope.location.state;
                        } else {
                            $scope.contactDetailsData.city = $scope.location.city;
                            $scope.contactDetailsData.state = $scope.location.state;
                        }
                    } 
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.location = {};
                    $scope.contactDetailsData.city = '';
                    $scope.contactDetailsData.state = '';
                    $scope.editData.city = '';
                    $scope.editData.state = '';
                }
            };
            UserService.getStateCity(check_zipcode, callbacks);
        } else {
            $scope.location = {};
            $scope.contactDetailsData.city = '';
            $scope.contactDetailsData.state = '';
            $scope.editData.city = '';
            $scope.editData.state = '';
        }
    };

//     $scope.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//     $scope.years = [];
//        var currentYear = new Date().getFullYear();
//            for (var year = 1950; year <= currentYear; year++) {
//            $scope.years.push(year);
//        } 

//    $scope.faceValues = [5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000];

//    $scope.diseasesList = ['Cancer', 'Diabetes', 'Anxiety /Depression /Bipolar','Heart Disorder', 'Chronic Pain',' Respiratory Disorder', 'Other Medical conditions','I have no medical conditions'];

$scope.bank_account_list = [
    'Local Bank' ,
    'Credit Union',
    'Direct Express Card'
];

$scope.diseasesList = [
    'Lung Disease, COPD, Emphysema, Asthma, Oxygen, or Inhalers?',
    'Heart attack, stroke, TIA, or stents?',
    'Have you ever been diagnosed with CHF?', 
    'Blood clots?',
    'Any cancers?', 
    'Diabetes or neuropathy or Amputation? (Pills and/or insulin?)',
    'High blood pressure or high cholesterol?',
    'Kidney or liver problems?',
    'Thyroid disease?',
    'Any treatment for anxiety or depression?',
    'Treatment needed for alcohol or drug abuse?',
    'Walking or oxygen equipment?',
    "Alzheimer's or dementia?",
    'Any hospitalizations that resulted in a stay for over 24 hours within the past year?',
    'Are you currently confined to a nursing home or skilled nursing facility?',
    'Any other medications?',
    '(If Applicable) Within the last 5 years have you had your license suspended or Revoked? DUI, DWI etc. or have had any felonies?',
    'None'
];


   $scope.updateDays = function() {
    var selectedMonth = parseInt($scope.editData.dobMonth);
    var selectDay = parseInt($scope.editData.dobDay);
    var selectedYear = parseInt($scope.editData.dobYear);
 
    var maxDays;
    switch (selectedMonth) {
      case 2: 
        maxDays = (selectedYear % 4 === 0 && (selectedYear % 100 !== 0 || selectedYear % 400 === 0)) ? 29 : 28; // Leap year calculation
        break;
      case 4: 
      case 6:
      case 9: 
      case 11:
        maxDays = 30;
        break;
      default:
        maxDays = 31;
    }
    $scope.maxDays = maxDays;
    $scope.days = [];
 
    for (var i = 1; i <= maxDays; i++) {
      $scope.days.push(i);
    }
    $scope.calculateEditAge()
 }
  

 $scope.calculateEditAge = function() {
    if (
        !$scope.editData ||
        !$scope.editData.dobYear || $scope.editData.dobYear == "0" ||
        !$scope.editData.dobMonth || $scope.editData.dobMonth == "0" || 
        !$scope.editData.dobDay || $scope.editData.dobDay == "0" 
    ) {
        // Do nothing if any field is missing or if dobMonth is 0/"0"
        $scope.editData.age = null;
        return;
    }
    

    // Create a birthdate using the selected values
    var birthDate = new Date($scope.editData.dobYear, $scope.editData.dobMonth - 1, $scope.editData.dobDay);
    var currentDate = new Date();

    // Calculate the age
    var age = currentDate.getFullYear() - birthDate.getFullYear();

    // Adjust if the birthday hasn't occurred this year
    if (currentDate.getMonth() < birthDate.getMonth() || 
        (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())) {
        age--;
    }

    $scope.editData.age = age;
}; 

  $scope.toggleEditSelection = function(val) {
    var medicationsArray;
    if (!$scope.editData.medications) {
        medicationsArray = [val];
    } else {
        medicationsArray = $scope.editData.medications.split(',').map(function(item) {
            return item.trim();
        });

        if (medicationsArray.includes(val)) {
            medicationsArray = medicationsArray.filter(function(item) {
                return item !== val;
            });
        } else {
            medicationsArray.push(val);
        }
    }

    $scope.editData.medications = medicationsArray.join(', ');
};

$scope.validateNumeric = function(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
        event.preventDefault();
    }
}; 

$scope.validatePhoneNumber = function(event) {
    const keyCode = event.which || event.keyCode;
    const isControlKey = [8, 9, 13, 27, 37, 38, 39, 40, 46].indexOf(keyCode) !== -1;
    const isNumber = keyCode >= 48 && keyCode <= 57;
    if (!isControlKey && !isNumber) {
        event.preventDefault();
    }
};

    // edit customer start
    $scope.editCustomer = function(){
        $scope.editCustomerInfo = true;
        $scope.editData = angular.copy($scope.contactDetailsData);
        console.log($scope.editData, "get edit record")
        $scope.editData.dobMonth = angular.copy($scope.contactMonth.toString());
        $scope.editData.dobDay = angular.copy($scope.contactDay.toString());
        $scope.editData.dobYear = angular.copy($scope.contactYear.toString());  
        $scope.editData.height_feet = angular.copy($scope.contactDetailsData.height_feet.toString())
        $scope.editData.height_inches = angular.copy($scope.contactDetailsData.height_inches.toString())
        // $scope.editData.face_value =  angular.copy($scope.contactDetailsData.face_value.toString())
        $scope.editData.email = $scope.contactDetailsData.email; 
        $scope.updateDays();
    } 

    // save customer start 
    $scope.saveCustomer = function(stageValue) {
        $scope.editCustomerInfo = false;
        $scope.editData.height_feet = parseFloat($scope.editData.height_feet);
        $scope.editData.height_inches = parseFloat($scope.editData.height_inches);
        // $scope.editData.face_value =  parseFloat($scope.editData.face_value); 

        if($scope.editData.sales_agent_id){
            $scope.editData.agent_id = (parseFloat($scope.editData.sales_agent_id));
        }else {
            $scope.editData.agent_id = (parseFloat($scope.editData.agent_id))
        }

        $scope.editData.contact_id = (parseFloat($scope.editData.id));
        $scope.contactMonth = parseFloat($scope.editData.dobMonth);
        $scope.contactDay = parseFloat($scope.editData.dobDay);
        $scope.contactYear = parseFloat($scope.editData.dobYear);
 
        if ($scope.contactMonth && $scope.contactDay && $scope.contactYear) {
            // $scope.editData.dob = $scope.contactDay + '/' + $scope.contactMonth + '/' + $scope.contactYear;
            $scope.editData.dob = $scope.contactDay + '/' + $scope.contactMonth + '/' + $scope.contactYear;
        } else {
            $scope.editData.dob = "";
        } 

        $scope.contactDetailsData = angular.copy($scope.editData);
        // console.log($scope.contactDetailsData, "get save data")
        // const firstName = $scope.contactDetailsData.beneficiary_first_name || '';
        // const lastName = $scope.contactDetailsData.beneficiary_last_name || '';
        // if (firstName || lastName) {
        //     $scope.contactDetailsData.beneficiary_name = [firstName, lastName].filter(Boolean).join(' ');
        // } else {
        //     $scope.contactDetailsData.beneficiary_name = null;
        // }

        $scope.savedFullname = $scope.contactDetailsData.first_name + ' ' + $scope.contactDetailsData.last_name;

        if($scope.contactFUllName !== $scope.savedFullname){
            $scope.contactFUllName = $scope.savedFullname;
            $scope.processContactName($scope.contactFUllName)
        }
        
        // $scope.editFaceValue.value = $scope.contactDetailsData.face_value;

        var existingDisease = $scope.contactDetailsData.medications;

        if(stageValue && $scope.contactDetailsData.root_disposition !== stageValue){
            $scope.contactDetailsData.root_disposition = stageValue
        }else {
            $scope.contactDetailsData.root_disposition = $scope.editData.root_disposition;
        }

        var updateData = $scope.contactDetailsData;
            // delete $scope.contactDetailsData.root_disposition;
            delete $scope.contactDetailsData.disposition;
            delete $scope.contactDetailsData.sales_agent_id;
            delete $scope.contactDetailsData.created_at;
            delete $scope.contactDetailsData.updated_at;

            if(!updateData.email) {
                updateData.email = ''
            }
            if(!updateData.gender) {
                updateData.gender = ''
            }
            // if(!updateData.face_value) {
            //     updateData.face_value = 0
            // }
            // if(updateData.bank_account == null) {
            //     updateData.bank_account = false;
            // }
            if(updateData.tobacco_user == null) {
                updateData.tobacco_user = false;
            }
            if(updateData.zip_code == null) {
                updateData.zip_code = 0;
            }


            var callbacks = {   
            success: function(data) {
                toaster.pop('success', 'Success', 'Contact Updated Successfully' );
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
         };
        UserService.updateContactDetailsView(updateData,callbacks);
    }  

    var weightInputValue = document.getElementById('weightInputValue');
    handleInputValue(weightInputValue)
    // var faceValueInput = document.getElementById('faceValueInput');
    // handleInputValue(faceValueInput)

    function handleInputValue(inputElement) {
        inputElement.addEventListener('mouseover', function() {
            if (inputElement.value === '0') {
                inputElement.value = '';
            }
        });
        inputElement.addEventListener('mouseout', function() {
            if (inputElement.value === '') {
                inputElement.value = '0'; 
            }
        });
    }

    $scope.dispositionStatus = false;
    $scope.updateStageValue = function(stage){
        $scope.editCustomer();
        $scope.saveCustomer(stage);
        $scope.dispositionStatus = true;
        $scope.processContactName($scope.savedFullname)
            var callbacks = {   
                success: function(data) {
                    // toaster.pop('success', 'Success', 'Contact Updated successfully');
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.loading = false;
                },
            };
            UserService.postetlOldDispostionStatus($scope.user_id,$scope.phoneNumber,$rootScope.oldStageValue,$scope.selectedStage,$scope.selectedStage,callbacks);
            // UserService.postetlDispostionStatus($scope.user_id,$scope.phoneNumber,$scope.selectedStage,$scope.selectedStage,callbacks);
            // UserService.stageDispositionSubmit($scope.user_id,$scope.phoneNumber,$scope.selectedStage,$scope.selectedStage,callbacks);
    }  

    $scope.characterCount = 0;
    $scope.updateCharacterCount = function() {
        $scope.characterCount = $scope.notes.length;
    }; 

    // $scope.isMaxLengthReached = function() {
    //     return $scope.characterCount >= 4096;
    // };

    $scope.handlePaste = function(event) {
        event.preventDefault(); 
            if (navigator.clipboard) {
                navigator.clipboard.readText().then(function(pastedData) {
                    var newLength = ($scope.notes ? $scope.notes.length : 0) + pastedData.length;
                    if (newLength > 4096) {
                        toaster.pop('error', 'Error', 'You cannot exceed 4096 characters.')
                    } else {
                        $scope.notes += pastedData;
                        $scope.updateCharacterCount();
                    }
                }).catch(function(err) {
                    console.error('Failed to read clipboard contents: ', err);
                });
            } else {
            }
    };

    $scope.limitInput = function(event) {
        if ($scope.notes.length >= 4096 && event.key !== "Backspace" && event.key !== "Delete") {
            event.preventDefault(); 
            toaster.pop('error', 'Error', 'You cannot exceed 4096 characters.')
        }
    };

    $scope.addNotes = function() { 
        var currentNotes = JSON.stringify($scope.contactDetailsData.notes);
        var newNotes = JSON.stringify($scope.notes); 
            if (currentNotes !== newNotes) {
                var callbacks = {   
                    success: function(data) {
                        toaster.pop('success', 'Success', 'Notes updated successfully');
                    },
                    failure: function(data) {
                        toaster.pop('error', 'Error', data.data);
                        $scope.loading = false;
                    },
                };
                $scope.contactDetailsData.notes = $scope.notes;
                UserService.notesUpdate($scope.phoneNumber,$scope.user_id,$scope.notes,callbacks);
            }else {}
     };
    
    $scope.callNotes = function() {
        $scope.notesblock= true; 
        $scope.application = false; 
        $scope.callsblock = false; 
    }

    // $scope.extractDate = function(dateTimeString) {
    //     const datePart = dateTimeString.split(' ')[0];
    //     return datePart;
    // }

    $scope.getCarrierArray = function(){
    	var callbacks = {
            success: function (data) {
                $scope.companies = data;
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getCarrierDetails(callbacks);
    };
    $scope.getCarrierArray()

    $scope.sortByName = function(data) {
        return data.sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
    };

    $scope.getAgentsArray = function(){
    	var callbacks = {
            success: function (data) {
                $rootScope.agentNames = $scope.sortByName(data);
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        UserService.getAgentDetails(callbacks);
    };
    $scope.getAgentsArray();

    $scope.getImageSrc = function(base64String) {
        if (base64String) {
            return 'data:image/png;base64,' + base64String;
        } else {
            return 'img/default-image.svg';
        }
    };

    $scope.getContactApplicationDetails = function(){
        $scope.loading = true;
        var callbacks = {   
            success: function(data) {
                $scope.applicationData = data;
                // $scope.mapAgentIdsToAgentNames();
                // $scope.mapCarrierIdsToCompanyNames();
                if($scope.applicationData.length === 0){
                    $scope.showNoOffersMessage = true;
                }else{
                    $scope.showNoOffersMessage = false;
                }
                $scope.loading = false;
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
                $scope.loading = false;
            },
        };
        UserService.getApplicationContactDetails($scope.contactDetailsData.id,$scope.user_id,callbacks);
    }
    

    $scope.extractDateFromTimestamp = function(timestamp) {
        // if (!timestamp) {
        //     return ''; 
        // }

        if (typeof timestamp !== 'string') {
            console.error('Expected a string but got:', typeof timestamp);
            return ''; // Return an empty string or handle the error as needed
        }
        var datePart = timestamp.split(' ')[0];
        var parts = datePart.split('-');
        if (parts.length !== 3) {
            throw new Error('Invalid date format');
        }
        var year = parts[0];
        var month = parts[1];
        var day = parts[2];
        // var shortYear = year.slice(2);
        return month + '/' + day + '/' + year;
    };

    // $scope.mapAgentIdsToAgentNames = function() {
    //     if ($rootScope.agentNames && $scope.applicationData) {
    //         $scope.applicationData.forEach(function(appData) {
    //             var selectedAgent = $rootScope.agentNames.find(function(agent) {
    //                 return agent.id === appData.split_agent_id;
    //             });
    //             if (selectedAgent) {
    //                 appData.agent_name = selectedAgent.name;
    //             } else {
    //                 appData.agent_name = 'N/A'
    //             }
    //         });
    //     } else {}
    // };

    // $scope.mapCarrierIdsToCompanyNames = function() {
    //     if ($rootScope.companies && $scope.applicationData) {
    //         $scope.applicationData.forEach(function(appData) {
    //             var selectedCompany = $rootScope.companies.find(function(company) {
    //                 return company.id === appData.carrier_id;
    //             });
    //             if (selectedCompany) {
    //                 appData.company_name = selectedCompany.name;
    //             } else {
    //                 appData.company_name = 'N/A'
    //             }
    //         });
    //     } else {}
    // };  
    
    $scope.openTranscriptView = function(transcriptId){
        console.log("Trigger view transcript"); // Log to console
        var baseUrl = window.location.origin; // Get the current base URL dynamically
        var url = baseUrl + "/v2/agent/contacts/" + encodeURIComponent($scope.contactName) + 
                  '/' + encodeURIComponent($scope.contactphoneNumber) + "/transcript/" + transcriptId;
        window.location.href = url; 
    }

    $scope.callApplication = function(){
        $scope.application = true;
        $scope.notesblock= false;
        $scope.callsblock = false;
        $scope.getContactApplicationDetails();
    }  
    // $scope.callApplication();

    $scope.applicationForm = function(){
        $scope.openApplicationFormModal();
    }

    $scope.openApplicationFormModal = function() {
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/application_form.html',
            controller: 'ApplicationFormCtrl',
            size: 'md',
            windowClass: 'custom-rounded-modal',
            backdrop: 'static',
            resolve: {
                object: function () {
                    return {
                        // firstName:$scope.username_firstName,
                        // lastName:$scope.username_lastName,
                        id:$scope.user_id,
                        // role:$scope.role,
                        contact_id:$scope.contactDetailsData.id
                    }
                }
            }
        });
            modalInstance.result.then(function (result) {
                    // $scope.selected = selectedItem;
                    if (result !== 'cancel') {
                        var callbacks = {
                            success: function (data) {
                                toaster.pop('success', 'Success', 'Created Application Successfully', 2000);
                                $scope.getContactApplicationDetails();
                                $scope.agentContactDetails();
                                $scope.application = true;
                                $scope.notesblock= false;
                                $scope.callsblock = false;
                            },
                            failure: function (data) {
                                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                            }
                        };
                        UserService.createApplication(result, callbacks);
                        UserService.postetlDispostionStatus($scope.user_id,$scope.phoneNumber,"Application Submitted","Application Submitted",callbacks);
                    }

            }, function () {
            
            });
    } 

    $scope.applicationContactEditForm = function(application){
        $scope.openApplicationContactEditFormModal(application);
    }

    $scope.openApplicationContactEditFormModal = function(edit_contact_application) {
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/application_page_edit.html',
            controller: 'ApplicationPageEditCtrl',
            size: 'md',
            windowClass: 'custom-rounded-modal',
            backdrop: 'static',
            resolve: {
                object: function () {
                    return {
                        application:edit_contact_application
                    }
                }
            }
        });
            modalInstance.result.then(function (selectedItem) {
                    if (selectedItem == 'ok') {
                        $scope.getContactApplicationDetails();
                    }
            }, function () {
            
            });
    } 

  }]);